const FormLabels = {
    "Volunteers": [
        {
            "Field": "Nr_Crt",
            "Type": "hidden"
        },
        {
            "Field": "Nume",
            "Type": "string"
        },
        {
            "Field": "Prenume",
            "Type": "string"
        },
        {
            "Field": "Telefon",
            "Type": "string"
        },
        {
            "Field": "Email",
            "Type": "email"
        },
        {
            "Field": "Anul_nasterii",
            "Type": "number"
        },
        {
            "Field": "Ocupatie",
            "Type": "string"
        },
        {
            "Field": "Numar_contract",
            "Type": "number"
        },
        {
            "Field": "Data_semnare",
            "Type": "date"
        },
        {
            "Field": "Data_expirare",
            "Type": "date"
        },
        {
            "Field": "Scan_contract",
            "Type": "file"
        }
    ],
    "Admini": [
        {
            "Field": "Nume",
            "Type": "list"
        }
    ],
    "Activities": [
        {
            "Field": "Tip_activitate",
            "Type": "select",
            "Source" : "types",
            "Dependable": true
        },
        {
            "Field": "Data_inceput",
            "Type": "date"
        },
        {
            "Field": "Data_sfarsit",
            "Type": "date"
        },
        {
            "Field": "Domeniu",
            "Type": "select",
            "Source": "domains",
            "Dependable": true
        },
        {
            "Field": "Nume",
            "Type": "select",
            "Source": "activities"
        },
        {
            "Field": "Descriere",
            "Type": "textarea"
        },
        {
            "Field": "Locatie",
            "Type": "string"
        },
        {
            "Field": "Ora_inceput",
            "Type": "time"
        },
        {
            "Field": "Ora_final",
            "Type": "time"
        },
        {
            "Field": "Necesar",
            "Type": "number"
        },
        {
            "Field": "Coordonator",
            "Type": "hidden",
            "Value": "userId"
        },
    ],
    "Announcements": [
        {
            "Field": "Titlu",
            "Type": "string"
        },
        {
            "Field": "Continut",
            "Type": "textarea"
        }
    ],
    "Courses": [
        {
            "Field": "Domeniu",
            "Type": "string"
        },
        {
            "Field": "Nume",
            "Type": "string"
        },
        {
            "Field": "Durata",
            "Type": "number"
        },
        {
            "Field": "Instructor",
            "Type": "string"
        },
        {
            "Field": "Descriere",
            "Type": "string"
        },
        {
            "Field": "Numar_minim",
            "Type": "number"
        },
        {
            "Field": "Numar_maxim",
            "Type": "number"
        }
    ],
    "VolunteersAtActivity": [
        {
            "Field": "Nume",
            "Type": "list"
        },
        {
            "Field": "Ora_sosire",
            "Type": "time"
        },
        {
            "Field": "Ora_plecare",
            "Type": "time"
        }
    ],
    "VolunteersAtCourse": [
        {
            "Field": "Prenume",
            "Type": "string"
        },
        {
            "Field": "Nume",
            "Type": "string"
        },
        {
            "Field": "Data",
            "Type": "date"
        }
    ]
}

export default FormLabels;


// WEBPACK FOOTER //
// ./src/reducers/ReducerFormLabels.js